import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import CurrencyFormat from 'react-currency-format';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { CompetitivenesIcon } from '../../../../../RevisaoPrecos/Components/CompetitivenesIcon';
import { LinkButton } from '../../../../../RevisaoPrecos/Components/LinkButton';
import { BaseCell } from '../../../../../RevisaoPrecos/Components/TableCells/BaseCell';

import { useCompetitorPriceStore } from '../../store/competitorPriceStore';
import { IRowData } from '../OfferTable/OfferTable';
import styles from './CompetitorPriceCell.module.scss';

const { MainContainer, SubContainer } = BaseCell;

export type CompetitorPriceCellProps = {
  rowData: IRowData;
};

const CompetitorPriceCell = ({ rowData, ...props }: CompetitorPriceCellProps) => {
  const productsToBePricedId = rowData.product_uuid || rowData.offer_dto?.id;
  const competitorsPrice = rowData.avg_competitiveness_price;
  const competitivenessIndicator = rowData.avg_competitiveness_price ? 'RULE_CPI_AVG' : null;

  const { key, options, setExpandedRowKey, addExpandedRowOption, removeExpandedRowOption, resetExpandedRow } = useCompetitorPriceStore();

  const isExpanded = useMemo(() => {
    return key === productsToBePricedId && options.includes('COMPETITORS');
  }, [key, options, productsToBePricedId]);

  const handleExpandCompetitorsRow = useCallback(() => {
    if (key !== productsToBePricedId) {
      resetExpandedRow();
    }

    if (isExpanded) {
      removeExpandedRowOption('COMPETITORS');
      return;
    }

    setExpandedRowKey(productsToBePricedId);
    addExpandedRowOption('COMPETITORS');
  }, [isExpanded, key, productsToBePricedId, resetExpandedRow, removeExpandedRowOption, setExpandedRowKey, addExpandedRowOption]);

  return (
    <section className={classNames(styles.container)} {...props}>
      <MainContainer>
        {competitorsPrice ? (
          <CurrencyFormat
            fixedDecimalScale
            decimalScale={2}
            value={competitorsPrice ?? null}
            displayType="text"
            prefix="R$ "
            decimalSeparator=","
            thousandSeparator="."
          />
        ) : (
          '--'
        )}
        <CompetitivenesIcon type={competitivenessIndicator || (competitorsPrice && 'RULE_CPI_AVG') || null} />
      </MainContainer>
      {competitorsPrice ? (
        <SubContainer>
          <LinkButton onClick={handleExpandCompetitorsRow}>
            {isExpanded ? (
              <>
                <MdKeyboardArrowUp size={10} />
                <p>Fechar</p>
              </>
            ) : (
              <>
                <MdKeyboardArrowDown size={10} />
                <p>Abrir</p>
              </>
            )}
          </LinkButton>
        </SubContainer>
      ) : null}
    </section>
  );
};

export default CompetitorPriceCell;
